/* unplugin-vue-components disabled */import { render } from "./AiStandardPage.vue?vue&type=template&id=288b8413&scoped=true"
import script from "./AiStandardPage.vue?vue&type=script&lang=js"
export * from "./AiStandardPage.vue?vue&type=script&lang=js"

import "./AiStandardPage.vue?vue&type=style&index=0&id=288b8413&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288b8413"]])

export default __exports__